<template>
  <b-row class="network-status-details">
    <b-col class="text-right pb-3">
      <span>{{ $t('network-status.report-details') }}</span>
      <a
        class="network-status-details__link blue-link"
        href
        @click.prevent="goToReport()"
        @mousedown.middle.prevent="goToReport()">
        {{ linkTitle }}
      </a>
    </b-col>
  </b-row>
</template>

<script>
import { onlyFirstCapitalized } from '@/services/stringHelper';

export default {
  computed: {
    linkTitle() {
      return onlyFirstCapitalized(this.$t('reports.network-status-history'));
    },
  },
  methods: {
    goToReport() {
      this.$emit('on-click-link');
    },
  },
};
</script>
